import { Box, Typography } from '@mui/material';
import { Card } from 'components/Card';
import { CardHeader } from 'components/Card/CardHeader';
import React from 'react';

export const HelpCard = ({
  url,
  title,
  description,
}: {
  url: string;
  title: string;
  description: string;
}) => (
  <Card>
    <CardHeader title={title} titleType='h3' description={description} href={url} />
  </Card>
);

export const HelpCards = ({
  title = 'Har du brug for hjælp?',
  helpItems,
}: {
  title?: string;
  helpItems: { title: string; url: string; description: string }[];
}) => {
  return (
    <>
      <Typography variant='h3Light'>{title}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 4 }}>
        {helpItems.map((card) => (
          <HelpCard
            key={card.url}
            url={card.url}
            title={card.title}
            description={card.description}
          />
        ))}
      </Box>
    </>
  );
};
